// Signed-agreement PDF generation for admin backfill/regeneration.
import { PDFDocument, rgb } from "pdf-lib";
import { PDF_CONFIG } from "./constants";
import { formatSpecialty, formatState } from "./helpers";

export const generateSignedPdfForRecord = async (record) => {
    try {
        // Fetch the original PDF template
        const pdfUrl = "/agreements/Stamp_Medical_Clinical_Contractor_Agreement.pdf";
        const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());

        // Load the PDF
        const pdfDoc = await PDFDocument.load(existingPdfBytes);

        // Get the target page
        const pages = pdfDoc.getPages();
        const pageIndex = pages.length - PDF_CONFIG.pageFromEnd;
        const targetPage = pages[pageIndex];

        // Draw signature image
        if (record.signature && record.signature.startsWith("data:image")) {
            try {
                const signatureImageBytes = await fetch(record.signature).then((res) => res.arrayBuffer());
                const signatureImage = await pdfDoc.embedPng(signatureImageBytes);

                targetPage.drawImage(signatureImage, {
                    x: PDF_CONFIG.signatureX,
                    y: PDF_CONFIG.signatureY,
                    width: PDF_CONFIG.signatureWidth,
                    height: PDF_CONFIG.signatureHeight,
                });
            } catch (sigError) {
                console.error("Error embedding signature:", sigError);
            }
        }

        // Draw business name on the By: line
        const businessName = record.dbaName || record.practiceName;
        if (businessName) {
            targetPage.drawText(businessName, {
                x: PDF_CONFIG.businessNameX,
                y: PDF_CONFIG.businessNameY,
                size: PDF_CONFIG.fontSize,
                color: rgb(0, 0, 0),
            });
        }

        // Draw name
        if (record.name) {
            targetPage.drawText(record.name, {
                x: PDF_CONFIG.nameX,
                y: PDF_CONFIG.nameY,
                size: PDF_CONFIG.fontSize,
                color: rgb(0, 0, 0),
            });
        }

        // Draw license type / state
        const licenseText = `${formatSpecialty(record.specialty)} / ${formatState(record.location)}`;
        targetPage.drawText(licenseText, {
            x: PDF_CONFIG.licenseX,
            y: PDF_CONFIG.licenseY,
            size: PDF_CONFIG.fontSize,
            color: rgb(0, 0, 0),
        });

        // Draw date (use submission timestamp)
        let dateStr;
        if (record.timestamp) {
            const date = record.timestamp.toDate ? record.timestamp.toDate() : new Date(record.timestamp);
            dateStr = date.toLocaleDateString();
        } else {
            dateStr = new Date().toLocaleDateString();
        }
        targetPage.drawText(dateStr, {
            x: PDF_CONFIG.dateX,
            y: PDF_CONFIG.dateY,
            size: PDF_CONFIG.fontSize,
            color: rgb(0, 0, 0),
        });

        // Save the PDF
        const pdfBytes = await pdfDoc.save();
        return new Blob([pdfBytes], { type: 'application/pdf' });
    } catch (error) {
        console.error("Error generating PDF:", error);
        return null;
    }
};
